/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The "Having trouble? Call {name} at {phone}" line from the invitation email
 * @export
 * @interface PortalHelpContact
 */
export interface PortalHelpContact {
    /**
     * 
     */
    name: string | null;
    /**
     * 
     */
    phone: string | null;
}

/**
 * Check if a given object implements the PortalHelpContact interface.
 */
export function instanceOfPortalHelpContact(value: object): value is PortalHelpContact {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function PortalHelpContactFromJSON(json: any): PortalHelpContact {
    return PortalHelpContactFromJSONTyped(json, false);
}

export function PortalHelpContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalHelpContact {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'phone': json['phone'],
    };
}

export function PortalHelpContactToJSON(json: any): PortalHelpContact {
    return PortalHelpContactToJSONTyped(json, false);
}

export function PortalHelpContactToJSONTyped(value?: PortalHelpContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'phone': value['phone'],
    };
}

